import { render, staticRenderFns } from "./HrSysDictValue.vue?vue&type=template&id=ffb8f03e&scoped=true&"
import script from "./HrSysDictValue.vue?vue&type=script&lang=js&"
export * from "./HrSysDictValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb8f03e",
  null
  
)

export default component.exports